// extracted by mini-css-extract-plugin
export default {"xs":"0","sm":"576","md":"768","lg":"892","xl":"1200"};